import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  overscroll-behavior-x: none;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }
`;

export const TableInner = styled.div`
  display: inline-flex;
  min-width: 100%;
  padding-right: 16px;
  box-sizing: border-box;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: auto;
`;

export const TableHeaderCell = styled.th<{
  width: string;
  isSticky?: boolean;
  isCompareRow?: boolean;
  hasActionCell?: boolean;
}>`
  padding: 12px 16px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: ${vars.color.textStrong};
  min-width: ${({ width }) => width};
  max-width: ${({ width, isSticky }) => (isSticky ? width : 'none')};
  width: ${({ width }) => width};
  ${({ isSticky, width }) =>
    isSticky &&
    `position: sticky; left: 0; z-index: 2; text-align: left; min-width: ${width}; max-width: ${width}; width: ${width};`}
  white-space: nowrap;
  background-color: ${vars.color.backgroundSurface};
  border-top: 1px solid ${vars.color.dividerThin};
  border-bottom: ${({ isCompareRow, hasActionCell }) =>
    isCompareRow || hasActionCell ? '0' : `1px solid ${vars.color.dividerThin}`};
`;

export const TableRow = styled.tr<{ hasBorder: boolean; isCompareRow?: boolean }>`
  height: 37px;
  ${({ isCompareRow }) => isCompareRow && `background-color: ${vars.color.backgroundOnElevated};`}
`;

export const TableDataCell = styled.td<{
  width: string;
  isSticky?: boolean;
  isCompareRow?: boolean;
  isHighlighted?: boolean;
  isRowHeader?: boolean;
}>`
  padding: 0;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: ${vars.color.textPrimary};
  border-bottom: ${({ isCompareRow }) => (isCompareRow ? '0' : `1px solid ${vars.color.dividerThin}`)};
  min-width: ${({ width }) => width};
  max-width: ${({ width, isSticky }) => (isSticky ? width : 'none')};
  width: ${({ width, isSticky }) => (isSticky ? width : 'auto')};
  ${({ isSticky, width }) =>
    isSticky &&
    `position: sticky; left: 0; z-index: 1; text-align: left; background-color: ${vars.color.backgroundElevated}; min-width: ${width}; max-width: ${width}; width: ${width};`}

  ${({ isCompareRow }) => isCompareRow && `background-color: ${vars.color.backgroundOnElevated};`}
  
  ${({ isRowHeader }) => isRowHeader && `font-weight: 600; color: ${vars.color.textStrong};`}
  
  ${({ isHighlighted, isRowHeader }) =>
    isHighlighted && `color: ${vars.color.subSkyBluePrimary}; font-weight: ${isRowHeader ? 600 : 500};`}

  &:first-of-type {
    text-align: left;
  }
`;

export const CompareItemWrapper = styled.div<{ isCompareRow?: boolean }>`
  display: flex;
  align-items: center;
  gap: 2px;
  background-color: ${({ isCompareRow }) => (isCompareRow ? vars.color.backgroundOnElevated : 'transparent')};
`;

export const CellText = styled.div<{
  isHighlighted?: boolean;
  isRowHeader?: boolean;
  isCompareRow?: boolean;
  hasImage?: boolean;
}>`
  padding: 12px 16px;
  display: block;
  width: 100%;
  background-color: ${({ isCompareRow }) => (isCompareRow ? vars.color.backgroundOnElevated : 'transparent')};
  text-align: ${({ isRowHeader }) => (isRowHeader ? 'left' : 'center')};

  color: ${({ isRowHeader }) => (isRowHeader ? vars.color.textStrong : vars.color.textPrimary)};
  font-weight: ${({ isRowHeader }) => (isRowHeader ? 600 : 500)};

  ${({ isHighlighted, isRowHeader }) =>
    isHighlighted && `color: ${vars.color.subSkyBluePrimary}; font-weight: ${isRowHeader ? 600 : 500};`}

  ${({ hasImage }) => hasImage && `padding-left: 2px;`}
  word-break: break-all;
`;

export const MySizeText = styled(CellText)`
  font-weight: 600;
  color: ${vars.color.textStrong};
  text-align: left;
  white-space: normal;
  word-break: keep-all;
`;

export const CompareButton = styled.button`
  display: flex;
  align-items: center;
  color: ${vars.color.subSkyBluePrimary};
  font-size: 12px;
  font-weight: 600;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  white-space: nowrap;
`;

export const CompareItemImage = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 16px;
  object-fit: cover;
  border-radius: 2px;
  flex-shrink: 0;
`;
